import axios from '@/plugins/axios'
import util from '@/services/util'

const ibeaconMessageApiEndPoint = 'admin/ibeacon-message'

export default {
    namespaced: true,

    state: {
        messages: [],
        total: 0
    },

    getters: {
        getIBeaconMessageById: state => id => {
            const message = state.messages.find(message => message.id === id)
            if (message) {
                return JSON.parse(JSON.stringify(message))
            }

            return null
        }
    },

    mutations: {
        setMessages (state, messages) {
            state.messages = messages
        },

        setMessageTotal (state, total) {
            state.total = total
        }
    },

    actions: {
        async fetchIBeaconMessages (context, query) {
            if (query?.from && query?.to) {
                const oldDate = new Date(query.to)
                const newDate = new Date(oldDate.setDate(oldDate.getDate() + 1))
                query.to = `${newDate.getFullYear()}-${util.getTwoDigitNumber(newDate.getMonth() + 1)}-${newDate.getDate()}`
            }
            const response = await axios.get(util.buildUrlWithQuery(ibeaconMessageApiEndPoint, query))
            const { messages, total } = response
            context.commit('setMessages', messages)
            context.commit('setMessageTotal', total)
        },

        async createIBeaconMessage (context, ibeaconMessageForm) {
            const { tabMessages, ...createIBeaconMessageForm } = ibeaconMessageForm

            const messageLineList = []
            const createMessageLinePromiseList = tabMessages.map(async messageLine => {
                if (messageLine.title && messageLine.subtitle) {
                    const formData = new FormData()
                    formData.append('title', messageLine.title ?? '')
                    formData.append('subtitle', messageLine.subtitle ?? '')
                    formData.append('condition', messageLine.condition ?? '')
                    formData.append('langCode', messageLine.langCode)
                    formData.append('thumbnail', messageLine.file)
                    const response = await axios.post(`${ibeaconMessageApiEndPoint}/messages`, formData)
                    messageLineList.push(response)
                }
            })
            await Promise.all(createMessageLinePromiseList)

            const ibeaconMessage = {
                effectiveStartDate: new Date(createIBeaconMessageForm.effectiveDates[0]).toISOString(),
                effectiveEndDate: new Date(createIBeaconMessageForm.effectiveDates[1]).toISOString(),
                messages: messageLineList
            }

            await axios.post(ibeaconMessageApiEndPoint, ibeaconMessage)
            context.dispatch('fetchIBeaconMessages')
        },

        async updateIBeaconMessage (context, ibeaconMessageForm) {
            const { id, ...updateForm } = ibeaconMessageForm
            const { tabMessages, ...updateIBeaconMessageForm } = updateForm

            const messageLineList = []
            const createAndUpdateMessageLinePromiseList = tabMessages.map(async messageLine => {
                if (messageLine.id) {
                    const formData = new FormData()
                    formData.append('id', messageLine.id)
                    formData.append('title', messageLine.title ?? '')
                    formData.append('subtitle', messageLine.subtitle ?? '')
                    formData.append('condition', messageLine.condition ?? '')
                    formData.append('langCode', messageLine.langCode)
                    formData.append('thumbnailUrl', messageLine.thumbnailUrl)

                    if (typeof messageLine.file !== 'string') {
                        formData.append('thumbnail', messageLine.file)
                    }

                    await axios.patch(`${ibeaconMessageApiEndPoint}/messages/${messageLine.id}`, formData)
                    const updatedMessage = await axios.get(`${ibeaconMessageApiEndPoint}/messages/${messageLine.id}`)
                    messageLineList.push(updatedMessage)
                } else {
                    if (messageLine.title && messageLine.subtitle) {
                        const formData = new FormData()
                        formData.append('title', messageLine.title ?? '')
                        formData.append('subtitle', messageLine.subtitle ?? '')
                        formData.append('condition', messageLine.condition ?? '')
                        formData.append('langCode', messageLine.langCode)
                        formData.append('thumbnail', messageLine.file)
                        const response = await axios.post(`${ibeaconMessageApiEndPoint}/messages`, formData)
                        messageLineList.push(response)
                    }
                }
            })
            await Promise.all(createAndUpdateMessageLinePromiseList)

            const ibeaconMessage = {
                effectiveStartDate: new Date(updateIBeaconMessageForm.effectiveDates[0]).toISOString(),
                effectiveEndDate: new Date(updateIBeaconMessageForm.effectiveDates[1]).toISOString(),
                messages: messageLineList,
                id
            }

            await axios.patch(`${ibeaconMessageApiEndPoint}/${id}`, ibeaconMessage)
            context.dispatch('fetchIBeaconMessages')
        },

        async deleteIBeaconMessage (context, ibeaconMessageForm) {
            const { id } = ibeaconMessageForm
            await axios.delete(`${ibeaconMessageApiEndPoint}/${id}`)
            context.dispatch('fetchIBeaconMessages')
        }
    }

}
